<article class="liquid-lp liquid-blog-item liquid-blog-item-grid liquid-blog-scheme-dark">

  <!-- The image link is a duplicate of the overlay link below and had no name
       of its own - its only name came from alt="Lates Post", the same string
       on every card. Hidden from assistive tech and taken out of the tab order
       so the card offers one named link rather than an anonymous extra; mouse
       users still click it, since aria-hidden does not affect pointer events.
       The image is decorative here: the title beside it names the article. -->
  <figure class="liquid-lp-media">
    <a [routerLink]="link" tabindex="-1" aria-hidden="true">
      <img [src]="news['image']" alt="" />
    </a>
  </figure>

  <div class="liquid-blog-item-inner">

    <!-- Carries the article title as its accessible name, as it did before. -->
    <a
      [routerLink]="link"
      class="liquid-overlay-link"
      [innerHTML]="titleHtml"
    ></a>

    <header class="liquid-lp-header">
      <h2
        class="liquid-lp-title font-weight-bold h3 size-sm"
        [innerHTML]="titleHtml"
      ></h2>
      <div class="liquid-lp-details">
        <time class="liquid-lp-date text-uppercase size-sm" [attr.datetime]="news['date']">{{news['date']}}</time>
      </div>
    </header>

    <div class="liquid-lp-excerpt">
      <p [innerHTML]="contentHtml"></p>
    </div>

    <footer class="liquid-lp-footer">
      <a
        [routerLink]="link"
        class="btn btn-naked text-uppercase ltr-sp-1 size-sm font-weight-bold liquid-lp-read-more"
      ><span><span class="btn-line btn-line-before"></span><span class="btn-txt">{{ readMore }}</span><span class="btn-line btn-line-after"></span></span></a>
    </footer>

  </div>
</article>
